import { connect } from 'react-redux'
import { bindActionCreators, compose } from 'redux'
import { withRouter } from 'react-router-dom'

import ScriptStructure from '../components/ScriptStructure'
import { fetchCreateScene, fetchCreateSlate, fetchCreateTake } from '../actions/Script'

const mapStateToProps = ({templates, script}) => ({
  template: templates.byId[templates.activeId],
  script
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchCreateScene,
    fetchCreateSlate,
    fetchCreateTake
  }, dispatch)
})

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(ScriptStructure)


// WEBPACK FOOTER //
// ./containers/ScriptStructure.js